/* wf-cart – tillbehörsförslag och tillägg i varukorgen (ersätter EGO/Opus Cart Upsell, 2026-09-11).
   Fungerar både i lådan (<cart-drawer>) och på varukorgssidan (<cart-items>). Antal/ta bort sköts
   av Dawns cart.js + cart-drawer.js. Här: "Lägg till" på förslag och toggle för tillägget.
   Efter varje ändring hämtas berörda sektioner i samma anrop och ritas om. */
(function () {
  'use strict';
  if (window.wfCartInit) return;
  window.wfCartInit = true;

  function headers() {
    return { 'Content-Type': 'application/json', Accept: 'application/json' };
  }

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function pageItems() {
    return document.querySelector('cart-items');
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* sektioner som ska hämtas: lådan alltid, sidan när den finns */
  function sectionsFor(root) {
    var list = ['cart-drawer', 'cart-icon-bubble'];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (root && root.tagName === 'CART-ITEMS' && items && footer) {
      list.push(items.dataset.id, footer.dataset.id);
    }
    return list;
  }

  function replaceInner(targetEl, html, selector) {
    if (!targetEl || !html) return;
    var src = parse(html).querySelector(selector);
    var dst = selector === '.shopify-section' ? targetEl : targetEl.querySelector(selector);
    if (src && dst) dst.innerHTML = src.innerHTML;
  }

  function rerender(root, response) {
    if (!response || !response.sections) return;
    var s = response.sections;
    var isEmpty = typeof response.item_count === 'number' ? response.item_count === 0 : false;
    var d = drawer();

    if (root && root.tagName === 'CART-ITEMS') {
      /* varukorgssidan: rita om sidan och lådan i bakgrunden utan att öppna den */
      var items = document.getElementById('main-cart-items');
      var footer = document.getElementById('main-cart-footer');
      if (items) replaceInner(items, s[items.dataset.id], '.js-contents');
      if (footer) {
        replaceInner(footer, s[footer.dataset.id], '.js-contents');
        footer.classList.toggle('is-empty', isEmpty);
      }
      root.classList.toggle('is-empty', isEmpty);
      if (d && s['cart-drawer']) {
        var srcDrawer = parse(s['cart-drawer']).querySelector('#CartDrawer');
        var dstDrawer = d.querySelector('#CartDrawer');
        if (srcDrawer && dstDrawer) dstDrawer.innerHTML = srcDrawer.innerHTML;
        d.classList.toggle('is-empty', isEmpty);
      }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) replaceInner(bubble, s['cart-icon-bubble'], '.shopify-section');
      return;
    }

    /* lådan: Dawns renderContents ritar om och öppnar lådan */
    if (!d) return;
    if (d.classList.contains('is-empty')) d.classList.remove('is-empty');
    if (typeof d.renderContents === 'function') {
      d.renderContents(response);
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wf-cart', cartData: response });
    }
  }

  function showError(root, message) {
    var box = null;
    if (root && root.tagName === 'CART-ITEMS') box = document.getElementById('cart-errors');
    if (!box) box = document.getElementById('CartDrawer-CartErrors');
    if (!box) return;
    box.textContent = message || (window.cartStrings && window.cartStrings.error) || 'Error';
    box.classList.add('wf-cart__errors');
    clearTimeout(box._wfTimer);
    box._wfTimer = setTimeout(function () { box.textContent = ''; }, 5000);
  }

  function addToCart(root, variantId) {
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionsFor(root).join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }

  function removeVariant(root, variantId) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ id: String(variantId), quantity: 0, sections: sectionsFor(root).join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }

  /* Hämta om lådan från servern utan att öppna den (används när något annat än lådan ändrat varukorgen). */
  function refreshDrawer(itemCount) {
    var d = drawer();
    if (!d) return;
    fetch(window.routes.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var src = parse(html).querySelector('#CartDrawer');
        var dst = d.querySelector('#CartDrawer');
        if (src && dst) dst.innerHTML = src.innerHTML;
        if (typeof itemCount === 'number') d.classList.toggle('is-empty', itemCount === 0);
      })
      .catch(function () {});
  }

  /* Dawns cart.js ritar bara om sidan när antal ändras där (källa 'cart-items'); håll lådan i synk. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'cart-items' || !pageItems()) return;
      refreshDrawer(event.cartData && event.cartData.item_count);
    });
  }

  /* Kollektionsfiltret och reservdelsportalen postar direkt mot /cart/add.js och skickar sedan
     'cart:refresh' (wf-collection-filter.liquid, vehicle-finder.liquid). Utan detta visar lådan
     sidladdningens innehåll – tom eller inaktuell – när kunden öppnar den efter ett snabbköp. */
  document.addEventListener('cart:refresh', function () {
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { refreshDrawer(cart && cart.item_count); })
      .catch(function () { refreshDrawer(); });
  });

  /* Trustpilot-widgeten i rubrikraden försvinner när Dawn ritar om lådan/sidan (innerHTML byts).
     Initiera om alla widgets som saknar iframe, så fort SDK:n finns. */
  function initTrustpilot() {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return;
    document.querySelectorAll('[data-wf-trustpilot]').forEach(function (el) {
      if (el.querySelector('iframe')) return;
      try { window.Trustpilot.loadFromElement(el, true); } catch (e) { /* ignorera */ }
    });
  }
  /* Kompakt Trustpilot-badge (mobil): betyg från TrustBox-datat, cachas i sessionStorage 1 h */
  var tpData = null;
  function fetchTrustpilot(bu, locale) {
    if (tpData) return tpData;
    var key = 'wfTrustpilot:' + bu + ':' + locale;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && cached.t && Date.now() - cached.t < 3600000) { tpData = Promise.resolve(cached.d); return tpData; }
    } catch (e) { /* ignorera */ }
    tpData = fetch('https://widget.trustpilot.com/trustbox-data/5419b637fa0340045cd0c936?businessUnitId=' + encodeURIComponent(bu) + '&locale=' + encodeURIComponent(locale))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var b = json && json.businessUnit;
        var d = b ? { score: b.trustScore, stars: b.stars, word: json.starsString || '', url: json.links && json.links.profileUrl } : null;
        try { if (d) sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: d })); } catch (e) { /* ignorera */ }
        return d;
      })
      .catch(function () { tpData = null; return null; });
    return tpData;
  }
  function initTrustpilotBadge() {
    document.querySelectorAll('[data-wf-tp]:not(.is-loaded)').forEach(function (el) {
      fetchTrustpilot(el.dataset.bu, el.dataset.locale || 'sv-SE').then(function (d) {
        if (!d || !d.score || el.classList.contains('is-loaded')) return;
        var score = String(Number(d.score).toFixed(1)).replace('.', ',');
        /* null-säkert: badge-markupen kan sakna barnen på sidor utan Trustpilot (2026-09-14) */
        var gradeEl = el.querySelector('.wf-cart__tp-grade');
        var scoreEl = el.querySelector('.wf-cart__tp-score');
        if (gradeEl) gradeEl.textContent = d.word;
        if (scoreEl) scoreEl.textContent = score + ' av 5';
        if (d.url) el.href = d.url;
        el.classList.add('is-loaded');
      });
    });
  }
  initTrustpilotBadge();

  var tpTimer = null;
  function scheduleTrustpilot() {
    clearTimeout(tpTimer);
    tpTimer = setTimeout(function () { initTrustpilot(); initTrustpilotBadge(); }, 60);
  }
  if (document.querySelector('[data-wf-trustpilot], [data-wf-tp]')) {
    var tpObserver = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) { scheduleTrustpilot(); return; }
      }
    });
    ['cart-drawer', 'cart-items'].forEach(function (tag) {
      var el = document.querySelector(tag);
      if (el) tpObserver.observe(el, { childList: true, subtree: true });
    });
    /* SDK:n laddas async i theme.liquid – fånga även fallet där den blir klar efter oss */
    var tpTries = 0;
    var tpPoll = setInterval(function () {
      initTrustpilot();
      if (++tpTries > 40 || document.querySelector('[data-wf-trustpilot] iframe')) clearInterval(tpPoll);
    }, 250);
  }

  function rootOf(el) {
    return el.closest('cart-items') || el.closest('cart-drawer');
  }

  /* "Lägg till" på ett tillbehörsförslag */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wf-add]');
    if (!btn) return;
    var root = rootOf(btn);
    if (!root) return;
    e.preventDefault();
    var card = btn.closest('[data-wf-upsell]');
    var select = card ? card.querySelector('select[data-wf-variant]') : null;
    var variantId = select ? select.value : btn.dataset.variantId;
    if (!variantId || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');
    addToCart(root, variantId)
      .then(function (json) {
        if (json.status || json.errors) {
          showError(root, json.description || json.message || json.errors);
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-disabled');
          return;
        }
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        var label = btn.querySelector('span');
        if (label && btn.dataset.addedText) label.textContent = btn.dataset.addedText;
        rerender(root, json);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
        showError(root);
      });
  });

  /* Ändringar i variantväljaren och toggeln får inte nå Dawns <cart-items>/<cart-drawer-items>,
     som tolkar varje change-händelse som ett antalsfält (capture-fas så att vi hinner först). */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.closest) return;
    var sel = el.closest('select[data-wf-variant]');
    if (sel || el.closest('input[data-wf-addon]')) e.stopPropagation();
    if (!sel) return;
    /* variantbyte: visa den valda variantens pris och peka knappen på rätt variant */
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('[data-wf-upsell]');
    if (!opt || !card) return;
    var sale = card.querySelector('.wf-cart__upsell-sale');
    var old = card.querySelector('.wf-cart__upsell-old');
    if (sale && opt.dataset.price) sale.textContent = opt.dataset.price;
    if (old && opt.dataset.old) old.textContent = opt.dataset.old;
    var btn = card.querySelector('[data-wf-add]');
    if (btn) btn.dataset.variantId = opt.value;
  }, true);

  /* toggle för tillägg (trädplantering) */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-wf-addon]');
    if (!input) return;
    var root = rootOf(input);
    if (!root) return;
    var variantId = input.dataset.variantId;
    if (!variantId) return;
    input.disabled = true;
    var request = input.checked ? addToCart(root, variantId) : removeVariant(root, variantId);
    request
      .then(function (json) {
        if (json.status || json.errors) {
          input.checked = !input.checked;
          input.disabled = false;
          showError(root, json.description || json.message || json.errors);
          return;
        }
        rerender(root, json);
      })
      .catch(function () {
        input.checked = !input.checked;
        input.disabled = false;
        showError(root);
      });
  }, true);
})();
